<template>
    <b-row>
        <b-col>
            <b-row>
                <b-col>
                    <label
                        :for="`column_dropdown_${group.id}`"
                        class="mr-2"
                    >{{$t("accessibility.selectColumn")}}</label>
                    <select
                        v-model="userDisplayColumSelection"
                        :id="`column_dropdown_${group.id}`"
                    >
                        <option
                            v-for="column in columnOptions"
                            :key="column.value"
                            :value="column.value"
                        >
                            {{column.text}}
                        </option>
                    </select>
                </b-col>
            </b-row>
            <b-row>
                 <b-col >
                    <ol>
                        <li
                            v-for="(feature, featureIndex) in featureData"
                            :key="`featureLI_${featureIndex}`"
                        >
                            <div class="d-flex justify-content-between">
                                <feature-info-item :feature="feature" :property="displayColumns[0]" class="mr-4" />
                                <div class="d-md-flex">
                                    <b-link class="accessible-link mr-4" @click="showDetails(featureIndex)">
                                        {{xi18n(i8nPrefix, 'openDetails', [feature[displayColumns[0].attribute].displayValue])}}
                                    </b-link>
                                    <b-link class="accessible-link" @click="showOnMap(featureIndex)">
                                        {{xi18n(i8nPrefix, 'showOnMap', [feature[displayColumns[0].attribute].displayValue])}}
                                    </b-link>
                                </div>
                            </div>
                        </li>
                    </ol>
                 </b-col>
            </b-row>
        </b-col>
    </b-row>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';
    import FeatureInfoItem from './FeatureInfoItem.vue';

    export default {
        props: { group: { type: Object, required: true }, groupIndex: { type: Number, required: true } },
        components: {  'feature-info-item': FeatureInfoItem },
        data() {
            return { userDisplayColumSelection: null, i8nPrefix: 'accessibility' };
        },
        watch: {
            columnOptions: {
                handler: function (newVal) {
                    this.userDisplayColumSelection = newVal[0].value;
                },
                immediate: true,
            }
        },
        computed: {
            ...mapGetters(['getSelectionObjectsSelectedItem']),
            columns: function () {
                return this.group.informationAttributes
                    .filter(
                        ({ displayInTable }) => displayInTable
                    );
            },
            columnOptions() {
                return this.columns.map(column => ({ value: column.attribute, text: column.alias || column.attribute }));
            },
            displayColumns: function () {
                if (this.userDisplayColumSelection) {
                    return this.columns.filter(column => column.attribute === this.userDisplayColumSelection);
                }
                return this.columns
                    .slice(0, 1);
            },
            featureData: function () {
                return this.group.objects.map(({ info }) => info);
            }
        },
        methods: {
            ...mapActions(['updateSelectionPointer', 'zoomToFeatures']),
            async showOnMap(index) {
                await this.updateSelectionPointer({ group: this.groupIndex, index });
                this.zoomToFeatures({
                    features: [this.getSelectionObjectsSelectedItem.feature],
                    zoomWhenOutOfView: false
                });
                this.$router.push({ name: 'accessibleInfo' });
            },
            showDetails(index) {
                this.updateSelectionPointer({ group: this.groupIndex, index });
                this.$router.push({ name: 'accessibleData' });
            }
        }
    };
</script>
